<template>
  <el-dialog title="留言板" :visible.sync="dialogFormVisible" width="1000px" :before-close="clearForm">
    <div>
      <el-divider></el-divider>
      <div class="intro">
        <p>尊敬的用户：</p>
        <p style="text-indent: 20px">
          为了向您提供更好的服务，我们希望收集您对易缆网操作和服务的宝贵看法和建议。收到反馈后，我们会认真研究您的建议，在3-5个工作日内
          给您回复。感谢您的支持！
        </p>
      </div>
    </div>
    <el-form :model="form" ref="ruleForm" label-position="left" :rules="rules">
      <el-form-item label="意见建议：" :label-width="formLabelWidth" prop="content">
        <el-input
          v-model="form.content"
          :autosize="{ minRows: 12 }"
          placeholder="示例：页面加载速度慢，请改进。（请补充详细问题描述，不超过500字。）"
          type="textarea"
          show-word-limit
          maxlength="500"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="resetForm('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="submitForm('ruleForm')"
        >提 交</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import { saveOpinion } from '@/api/message'
export default {
  data() {
    return {
      dialogFormVisible: false,
      form: {
        content:''
      },
      formLabelWidth: "96px",
      rules: {
          content: [
            { required: true, message: '请填写意见建议', trigger: 'blur' },
          ],
      }
    };
  },
  methods:{
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            saveOpinion(this.form).then(res =>{
              if(res.data.code == 0){
                this.dialogFormVisible = false
                this.$message.success('提交成功，感谢您的反馈！');
                this.form.content = '';
              }
            })
          } else {
            // console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName){
        if(this.$refs[formName]){
            this.$refs[formName].resetFields();
        }
        this.dialogFormVisible = false
      },
      clearForm(){
        this.form.content = '';
        this.$refs.ruleForm.clearValidate()
        this.dialogFormVisible = false;
      }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  padding-bottom: 0px;
}
::v-deep .el-dialog__body {
  padding: 0px 20px;
}
.intro {
  margin-bottom: 20px;
  color: #333;
  font-size: 14px;
  line-height: 22px;
  p {
    margin: 0;
  }
}
</style>
